import { memo } from 'react'
import { Box, Typography } from '@mui/material'
import { useAuth } from '../../context/AuthContext'
import { getUserFullName } from '../../lib/userUtils'

/**
 * DashboardHeader component - Reusable dashboard header with welcome message
 */
export const DashboardHeader = memo(({ title }) => {
  const { userProfile } = useAuth()

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Welcome back, {userProfile ? getUserFullName(userProfile) : 'Guest'}
      </Typography>
    </Box>
  )
})
